import { ChipProps } from "@mui/material"

export const UserRole = {
  Service: 'service',
  Admin: 'admin',
  General: 'general',
  Guest: 'guest',
  Demo: 'demo',
  CareNet: 'carenet'
} as const

export type UserRoleType = (typeof UserRole)[keyof typeof UserRole]

export type UserRoleProps = {
  label: string
  color: ChipProps['color']
}
export const UserRoles: ({
  key: UserRoleType
} & UserRoleProps)[] = [
  { key: UserRole.CareNet, label: 'ケアネット', color: 'careNet' },
  { key: UserRole.General, label: '一般', color: 'warning' },
  { key: UserRole.Guest, label: 'ゲスト', color: 'secondary' },
  { key: UserRole.Demo, label: '匿名化', color: 'secondary' },
  { key: UserRole.Admin, label: '管理者', color: 'success' },
  { key: UserRole.Service, label: 'サービス', color: 'info' }
]
export const GetUserRoleProps = (role: UserRoleType | string): UserRoleProps => {
  return UserRoles.find(r => r.key === role) ?? {
    label: role as string,
    color: "error"
  }
}